export type ProductType = "ritual" | "module" | "capsule";
export type ProductVisualLine = "core" | "sculp" | "brand";
export type ProductDataRitual = "core" | "sculp" | "addon";

function normalizeProductId(productId: string): string {
  return productId.trim().toLowerCase();
}

export function productVisualLine(input: {
  productId: string;
  productType?: ProductType;
}): ProductVisualLine {
  if (input.productType !== undefined && input.productType !== "ritual") return "brand";

  const id = normalizeProductId(input.productId);
  if (id.startsWith("addon-") || id.startsWith("prod_cap_") || id.startsWith("prod_mod_")) return "brand";
  if (id.includes("core")) return "core";
  if (id.includes("sculp") || id.includes("sculpt")) return "sculp";
  return "brand";
}

export function productDataRitual(input: {
  productId: string;
  productType?: ProductType;
}): ProductDataRitual {
  const line = productVisualLine(input);
  return line === "brand" ? "addon" : line;
}
